<template>
  <div class="search-result-card-wrapper certification">
    <div class="search-result-card-section-group left">
      <div class="group">
        <div class="search-result-card-section" id="borrowername">
          <div
            class="borrower-name"
            :title="decodeHTMLEncodedStr(certification.borrowerFullName)"
          >
            {{
              decodeHTMLEncodedStr(certification.borrowerFullName) || "No Name"
            }}
          </div>
        </div>

        <div class="search-result-card-section" id="status">
          <div class="xcertificationstatus">
            {{ certification.certificationStatusTypeDescription }}
          </div>
        </div>
      </div>
      <div class="group">
        <div class="search-result-card-section referenceid" id="referenceid">
          <h5
            class="icon icon-single-person"
            :title="certification.referenceId"
          >
            {{ certification.referenceId }}
          </h5>
        </div>
        <div class="search-result-card-section" id="amount">
          <span>{{ certification.loanAmountFormatted }}</span>
        </div>
      </div>

      <div class="search-result-card-section lender">
        <h5 class="icon icon-hand-shake" :title="certification.lenderName">
          {{ certification.lenderName }}
        </h5>
      </div>

      <div
        v-if="showCreatedDate"
        class="search-result-card-section"
        id="createdatutc"
      >
        <span style="color: red">{{ certification.createdAtUtc }}</span>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { PropType } from "vue";
import useFunctions from "@/use/functions1";
import { useDebugDateKey } from "@/composables/useDebugDateKey";

const { decodeHTMLEncodedStr } = useFunctions();
const { showCreatedDate } = useDebugDateKey();

const props = defineProps({
  certification: {
    type: Object as PropType<any>,
    required: true,
  },
});
</script>

<style
  scoped
  src="@/assets/css/search-page/search-page-result-card.css"
></style>
